'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0px;\n  left: 0px;\n  opacity: 0.4;\n  background-color: ', ';\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  will-change: opacity;\n  pointer-events: auto;\n  z-index: -1;\n'], ['\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0px;\n  left: 0px;\n  opacity: 0.4;\n  background-color: ', ';\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  will-change: opacity;\n  pointer-events: auto;\n  z-index: -1;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  opacity: 1;\n  padding: 0px;\n  z-index: 9999;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  -webkit-transition: opacity 600ms, visibility 600ms;\n  transition: opacity 600ms, visibility 600ms;\n  '], ['\n  position: fixed;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  opacity: 1;\n  padding: 0px;\n  z-index: 9999;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  -webkit-transition: opacity 600ms, visibility 600ms;\n  transition: opacity 600ms, visibility 600ms;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  min-height: 400px;\n  padding: 0px;\n  color: ', ';\n  z-index: 1;\n  margin-left: auto;\n  margin-right: auto;\n  height: 100%;\n  overflow: auto;\n'], ['\n  min-height: 400px;\n  padding: 0px;\n  color: ', ';\n  z-index: 1;\n  margin-left: auto;\n  margin-right: auto;\n  height: 100%;\n  overflow: auto;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding: 20px;\n  text-align: left;\n  padding-bottom: 10px;\n  margin: 50px 20% 0px 15%;\n  border-bottom: 1px solid ', ';\n  letter-spacing: 0.25em;\n  font-size: 13px;\n  width: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 1;\n  background: ', ';\n  border-radius: 5px 5px 0px 0px;\n  position: relative;\n'], ['\n  padding: 20px;\n  text-align: left;\n  padding-bottom: 10px;\n  margin: 50px 20% 0px 15%;\n  border-bottom: 1px solid ', ';\n  letter-spacing: 0.25em;\n  font-size: 13px;\n  width: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  z-index: 1;\n  background: ', ';\n  border-radius: 5px 5px 0px 0px;\n  position: relative;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  margin-left: auto;\n  margin-right: auto;\n  width: ', ';\n  padding: ', ';\n  z-index: 2;\n  background: ', ';\n  position: relative;\n'], ['\n  margin-left: auto;\n  margin-right: auto;\n  width: ', ';\n  padding: ', ';\n  z-index: 2;\n  background: ', ';\n  position: relative;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  margin-left: auto;\n  margin-right: auto;\n  height: 50px;\n  margin-bottom: 50px;\n  width: ', ';\n  z-index: 1;\n  background: ', ';\n  border-radius: 0px 0px 5px 5px;\n  box-shadow:0 15px 35px -10px rgba(0,0,0,0.5);\n  position: relative;\n'], ['\n  margin-left: auto;\n  margin-right: auto;\n  height: 50px;\n  margin-bottom: 50px;\n  width: ', ';\n  z-index: 1;\n  background: ', ';\n  border-radius: 0px 0px 5px 5px;\n  box-shadow:0 15px 35px -10px rgba(0,0,0,0.5);\n  position: relative;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

var _MozartButton = require('../../MozartButton');

var _MozartButton2 = _interopRequireDefault(_MozartButton);

var _MozartCloseButton = require('../../MozartButton/MozartCloseButton');

var _MozartCloseButton2 = _interopRequireDefault(_MozartCloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BackGroundDiv = _styledComponents2.default.div(_templateObject, _color2.default.blue_main);

var BackdropStyleDiv = _styledComponents2.default.div(_templateObject2);

var ModalStyleDiv = _styledComponents2.default.div(_templateObject3, _color2.default.grey_main);

var ModalTitleDiv = _styledComponents2.default.div(_templateObject4, _color2.default.blue_accent, function (props) {
  return props.width;
}, _color2.default.white);

var ModalContent = _styledComponents2.default.div(_templateObject5, function (props) {
  return props.width;
}, function (props) {
  return props.contentPadding;
}, _color2.default.white);

var ModalFooter = _styledComponents2.default.div(_templateObject6, function (props) {
  return props.width;
}, _color2.default.white);

var MozartModal = function (_Component) {
  _inherits(MozartModal, _Component);

  function MozartModal(props) {
    _classCallCheck(this, MozartModal);

    var _this = _possibleConstructorReturn(this, (MozartModal.__proto__ || Object.getPrototypeOf(MozartModal)).call(this, props));

    var id1 = props.id ? props.id : _this.generate();

    _this.state = {
      visibility: 'hidden',
      opacity: 0,
      modalContainerId: props.id ? props.id : id1,
      contentPadding: '50px'
    };
    return _this;
  }

  _createClass(MozartModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var elem = document.getElementById(this.state.modalContainerId);
      if (elem !== null) {
        elem.parentElement.removeChild(elem);
        document.body.appendChild(elem);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show && !this.props.show) {
        this.createStyle();
      }
      if (!nextProps.show && this.props.show) {
        this.deleteStyle();
      }
    }
  }, {
    key: 'generate',
    value: function generate() {
      var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var result = '';
      for (var i = 5; i > 0; --i) {
        result += chars[Math.round(Math.random() * (chars.length - 1))];
      }
      return result;
    }
  }, {
    key: 'createStyle',
    value: function createStyle() {
      this.setState({
        style: _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: '\n        body { overflow: hidden !important; }\n      ' } })
      });
    }
  }, {
    key: 'deleteStyle',
    value: function deleteStyle() {
      this.setState({
        style: ''
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          show = _props.show,
          disableSubmit = _props.disableSubmit,
          submitLabel = _props.submitLabel,
          children = _props.children,
          handleSubmit = _props.handleSubmit,
          width = _props.width,
          onClose = _props.onClose,
          contentPadding = _props.contentPadding,
          className = _props.className,
          themeId = _props.themeId;

      var toUpperCaseTitle = title.toUpperCase();
      var backgroundStyle = show ? { visibility: 'visible', opacity: 1 } : { visibility: 'hidden', opacity: 0 };
      return _react2.default.createElement(
        'div',
        { 'data-qa': this.props.testId, 'data-theme': themeId },
        this.state.style,
        _react2.default.createElement(
          BackdropStyleDiv,
          { style: backgroundStyle, id: this.state.modalContainerId, className: className },
          show && _react2.default.createElement(
            ModalStyleDiv,
            null,
            _react2.default.createElement(
              ModalTitleDiv,
              { width: width },
              toUpperCaseTitle,
              _react2.default.createElement(_MozartCloseButton2.default, {
                onClick: function onClick() {
                  if (onClose) {
                    onClose();
                  }
                },
                style: {
                  position: 'absolute',
                  top: '7px',
                  right: '15px',
                  width: '34px',
                  height: '34px'
                }
              })
            ),
            _react2.default.createElement(
              ModalContent,
              { width: width, contentPadding: contentPadding },
              children
            ),
            _react2.default.createElement(
              ModalFooter,
              { width: width },
              !disableSubmit && handleSubmit && _react2.default.createElement(_MozartButton2.default, {
                background: true,
                data: submitLabel,
                onClick: handleSubmit,
                style: {
                  marginRight: '50px',
                  float: 'right',
                  width: '110px'
                }
              })
            ),
            _react2.default.createElement(BackGroundDiv, { onClick: function onClick() {
                if (show && onClose) {
                  onClose();
                }
              }, style: { zIndex: '0' } })
          )
        )
      );
    }
  }]);

  return MozartModal;
}(_react.Component);

MozartModal.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** id attribute */
  id: _propTypes2.default.string,
  /** title of the dialog */
  title: _propTypes2.default.string,
  /** submit button label */
  submitLabel: _propTypes2.default.string,
  /** custom width */
  width: _propTypes2.default.string,
  /** callback when closed */
  onClose: _propTypes2.default.func.isRequired,
  /** submit button label */
  handleSubmit: _propTypes2.default.func,
  /** content of modal */
  children: _propTypes2.default.node,
  /** hide submit button */
  disableSubmit: _propTypes2.default.bool,
  /** if true modal show up if false modal hidden */
  show: _propTypes2.default.bool,
  /** if content padding needed */
  contentPadding: _propTypes2.default.string,
  /** if class name is needed */
  className: _propTypes2.default.string
};
MozartModal.defaultProps = {
  title: '',
  id: 'MozartModal',
  width: '700px',
  contentPadding: '50px',
  disableSubmit: false,
  testId: 'MozartModal',
  themeId: 'MozartModal',
  className: 'mozart-modal'
};
exports.default = MozartModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartDialog/MozartModal/MozartModal.js
// module id = 158
// module chunks = 1